import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns List of Recurring Transfers
 @return { Array }
 */
export const getRecurringTransfers = state => state.recurringTransfers

/** returns Schedule Types
 @return { Array }
 */
export const getScheduleTypes = state => state.scheduleTypes

/** returns Beneficiary Name
 @return { Array }
 */
export const getBeneficiaryName = state => state.beneficiaryName

/** returns Last Recurring Transfers Info
 @return { Object }
 */
export const getLastRecurringTransfersInfo = state => state.lastRecurringTransfersInfo

/** returns Has More Recurring Transfers
 @return { Boolean }
 */
export const getRecurringTransfersHasMore = state => state.recurringTransfersHasMore
